(() => {
  if (document.documentElement.dataset.pdpRestockEnabled !== 'false') return;
  const blockRestockSignup = (event) => {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest('[id^="appikon-bis-"], [class*="appikon-bis-"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  };
  window.addEventListener('submit', blockRestockSignup, true);
  window.addEventListener('click', blockRestockSignup, true);
})();
